import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  DatePicker,
  Input,
  message,
  Row,
  Spin,
  Select,
  Divider,
  Tooltip,
  Space,
  Collapse,
  Typography,
} from 'antd';

import { getToken } from '../../helpers';
import { API, BEARER } from '../../constant';
import { useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { getUserDetails } from '../../helpers';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
  RollbackOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  ExclamationCircleTwoTone,
} from '@ant-design/icons';
import { errorHandler } from '../../utils/errorHandling';
import {
  getMonthNameFromStringDate,
  getMonthIndex,
  getDateFromMonth,
  dateFormat,
  monthNames,
  delay,
} from '../../utils/dateUtils';
import {
  coreProductStatusArray as coreProductStatusList,
  catalogProductStatusList,
  paymentModelOptionArray,
  patternOptionArray,
  freshnessOptionArray,
  fabricSpecialAttributeOptionArray,
  knitWovenOptionArray,
  weightOptionArray,
  colorDepthOptionArray,
  lifeOccasionOptionArray,
  tnaStatusOptionArray,
  sleeveOptionArray,
  designCategoryOptionArray,
  toProperCase,
} from '../../utils/generic'; // dropdown options arrays
import moment from 'moment'; // for date handling
import { isNumber, update } from 'lodash';

const userRoleAndPermission = require('../../config/userPermision.json');
const mandatoryFieldsConfig = require('../../config/mandatoryFieldsConfig.json');
const mandatoryIconColor = '#F2B50B';

const userRolesAllowedForAttributes = {
  edit: {
    designAttribute: [
      ...userRoleAndPermission?.userRole?.designTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    merchAttribute: [
      ...userRoleAndPermission?.userRole?.merchTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    planningAttribute: [
      ...userRoleAndPermission?.userRole?.planningTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
  },
  view: {},
}; // to control the access of edit and view permissions for different attributes based on user roles

const ShopifyProductDetails = () => {
  const navigate = useNavigate(); // to navigate between pages
  const location = useLocation(); // to get the state passed from previous page on navigation

  const user = getUserDetails();
  console.log(user, '48');

  const [dataform] = Form.useForm(); // form instance for main form
  const [editData, setEditData] = useState(null); // to store the data of the product being edited
  const [updatedValues, setUpdatedValues] = useState({}); // to store the updated values of the product details to be sent in the API request body on save

  const [supplierList, setSupplierList] = useState([]);
  const [washcareList, setWashcareList] = useState([]);
  const [launchMastersList, setLaunchMastersList] = useState([]);
  const [seasonMastersList, setSeasonMastersList] = useState([]);
  const [familyColorList, setFamilyColorList] = useState([]);
  const [filterColorList, setFilterColorList] = useState([]);

  const [colorList, setColorList] = useState([]);
  const [fitList, setFitList] = useState([]);
  const [sizeList, setSizeList] = useState([]);

  const [silhouetteList, setSilhouetteList] = useState([]);
  const [specialAttributeList, setSpecialAttributeList] = useState([]);
  const [trendList, setTrendList] = useState([]);
  const [patternList, setPatternList] = useState([]);

  // new dropdown lists added per requirements

  const [productTypeList, setProductTypeList] = useState([]);
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [shopifyProductTypeList, setShopifyProductTypeList] = useState([]);

  const [selectedLaunchNew, setSelectedLaunchNew] = useState(0); // to store the selected launch drop value in the edit form
  const [isModalOpen, setIsModalOpen] = useState(false); // to control the visibility of the edit modal
  const [isModalOpenTrend, setIsModalOpenTrend] = useState(false); // to control the visibility of the edit modal for trend attribute

  const [modalform] = Form.useForm(); // form instance for edit modal
  const [modalformTrend] = Form.useForm(); // form instance for trend attribute edit modal

  const [saving, setSaving] = useState(false); // to show loading indicator on save button while saving the updated product details
  const [isEditable, setIsEditable] = useState(true); // to control the editability of the form fields based on the product status and user role
  const [fetching, setFetching] = useState(false); // to show loading indicator while fetching the product details data from API

  const [isLoading1, setIsLoading] = useState(true); // to show loading indicator while fetching the product details data from API and during save operation

  const [productOptionDetails, setProductOptionDetails] = useState([]); // not used may be

  const [variantList, setVariantList] = useState([]); // to store the list of product variants for the product being edited
  const [derivedAttributes, setDerivedAttributes] = useState(false); // not used
  const [coreProductData, setCoreProductData] = useState(null); // main data object for the main form presented in this page.

  const authToken = getToken(); // to store the auth token for API requests
  const { TextArea } = Input; // to use the TextArea component of antd Input in the form

  //   console.log(location, 'line no 69');
  //   return;

  const fetchCoreProductDetails = async (token, catalogProductId) => {
    // function to fetch the details of the product being edited from API and set the form fields with the fetched data
    setIsLoading(true);
    // await delay(5000);
    try {
      const response = await fetch(
        `${API}/catalog-products/${catalogProductId}?populate[channel][populate]=true&populate[shopify_product][populate][shopify_product_type]=true&populate[core_product][populate][launch_masters]=true&populate[core_product][populate][indent_sheets]=true&populate[core_product][populate][techpacks]=true&populate[core_product][populate][sub_color_lists]=true&populate[core_product][populate][fits_list]=true&populate[core_product][populate][size_list]=true&populate[core_product][populate][garment_special_attributes]=true&populate[core_product][populate][product_option_type]=true&populate[core_product][populate][product_variants]=true`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const responseData = await response.json();
      console.log(responseData, 'Catalog product details response check');
      // return;
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        // return;

        // data1 = responseData.data.map((entry) => {
        //---------map start
        let entry = responseData?.data;

        // Catalog Requirement
        let channelObjArray = [];
        if (entry?.attributes?.channel?.data?.length > 0) {
          console.log(entry?.attributes?.channel?.data);
          channelObjArray = entry.attributes.channel?.data?.map(
            (channelObject) => {
              console.log(channelObject);
              return {
                marketPlaceId: channelObject?.id,
                marketPlaceName: channelObject?.attributes?.marketplace_name,
                marketPlaceStatus: channelObject?.attributes?.status,
              };
            },
          );
        }

        // Catalog Requirement
        let shopifyProductObjectObj;
        if (entry?.attributes?.shopify_product) {
          console.log(entry?.attributes?.shopify_product?.data);
          let shopifyProductObject = entry?.attributes?.shopify_product;
          console.log(shopifyProductObject);
          shopifyProductObjectObj = {
            shopifyProductObjectRefId: shopifyProductObject?.data?.id,
            shopifyProductObjectHandle:
              shopifyProductObject?.data?.attributes?.handle,
            shopifyProductObjectTitle:
              shopifyProductObject?.data?.attributes?.title,
            shopifyProductObjectBodyHtml:
              shopifyProductObject?.data?.attributes?.body_html,
            shopifyProductObjectVendor:
              shopifyProductObject?.data?.attributes?.vendor,
            shopifyProductObjectTags:
              shopifyProductObject?.data?.attributes?.tags,
            shopifyProductObjectPublished:
              shopifyProductObject?.data?.attributes?.published,
            shopifyProductObjectSeoTitle:
              shopifyProductObject?.data?.attributes?.seo_title,
            shopifyProductObjectSeoDescription:
              shopifyProductObject?.data?.attributes?.seo_description,
            shopifyProductObjectProductType:
              shopifyProductObject?.data?.attributes?.product_type,
            shopifyProductObjectProductCatagory:
              shopifyProductObject?.data?.attributes?.product_category ||
              'Uncategorized',
            shopifyProductObjectOption1Name:
              shopifyProductObject?.data?.attributes?.option1_name,
            shopifyProductObjectOption2Name:
              shopifyProductObject?.data?.attributes?.option2_name,
            shopifyProductObjectOption3Name:
              shopifyProductObject?.data?.attributes?.option3_name,
            shopifyProductObjectLaunchName:
              shopifyProductObject?.data?.attributes?.launch_name,
            shopifyProductObjectLaunchSeason:
              shopifyProductObject?.data?.attributes?.launch_season,
              
            shopifyProductObjectShopifyProductVariants:
              shopifyProductObject?.data?.attributes?.shopify_product_variants,
            shopifyProductObjectColorGroupId:
              shopifyProductObject?.data?.attributes?.color_group_id,
            shopifyProductObjectColorGroupRef:
              shopifyProductObject?.data?.attributes?.color_group_ref,
            shopifyProductObjectColorVariants:
              shopifyProductObject?.data?.attributes?.color_variants,
            shopifyProductObjectComplementary:
              shopifyProductObject?.data?.attributes?.complementary,
            shopifyProductObjectCountryManufacture:
              shopifyProductObject?.data?.attributes?.country_of_manufacture,
            shopifyProductObjectHeroProduct:
              shopifyProductObject?.data?.attributes?.hero_product,
            shopifyProductObjectCohortRemarks1:
              shopifyProductObject?.data?.attributes?.cohort_remarks_1,
            shopifyProductObjectCohortRemarks2:
              shopifyProductObject?.data?.attributes?.cohort_remarks_2,
            shopifyProductObjectCohortRemarks3:
              shopifyProductObject?.data?.attributes?.cohort_remarks_3,
            shopifyProductObjectCollection:
              shopifyProductObject?.data?.attributes?.collection,
            shopifyProductObjectShopifyStatus:
              shopifyProductObject?.data?.attributes?.shopify_status,

            shopifyProductObjectFabric:
              shopifyProductObject?.data?.attributes?.fabric,
            shopifyProductObjectKnitType:
              shopifyProductObject?.data?.attributes?.knit_type,
            shopifyProductObjectLifeOccasion:
              shopifyProductObject?.data?.attributes?.life_occasion,
            shopifyProductObjectMaterial:
              shopifyProductObject?.data?.attributes?.material,
            shopifyProductObjectMaterialCare:
              shopifyProductObject?.data?.attributes?.material_care,
            shopifyProductObjectModelInfo:
              shopifyProductObject?.data?.attributes?.model_info,
            shopifyProductObjectSleeves:
              shopifyProductObject?.data?.attributes?.sleeves,
            shopifyProductObjectWeight:
              shopifyProductObject?.data?.attributes?.weight,
            shopifyProductObjectPattern:
              shopifyProductObject?.data?.attributes?.pattern,
            shopifyProductObjectWeaveStructure:
              shopifyProductObject?.data?.attributes?.weave_structure,
            shopifyProductObjectLength:
              shopifyProductObject?.data?.attributes?.length,
            shopifyProductObjectHem:
              shopifyProductObject?.data?.attributes?.hem,
            shopifyProductObjectPlacket:
              shopifyProductObject?.data?.attributes?.placket,
            shopifyProductObjectCuff:
              shopifyProductObject?.data?.attributes?.cuff,
            shopifyProductObjectShopifyProductTypeId:
              shopifyProductObject?.data?.attributes?.shopify_product_type?.data
                ?.id,
          };
        }

        // Catalog Requirement
        let launchObj = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.launch_masters
            ?.data?.length > 0
        ) {
          console.log(
            'core product details 414',
            entry?.attributes?.core_product?.data?.attributes?.launch_masters
              ?.data,
          );
          launchObj =
            entry?.attributes?.core_product?.data?.attributes?.launch_masters?.data?.map(
              (launchMasterObject) => {
                console.log(launchMasterObject);
                return {
                  launchRefId: launchMasterObject?.id,
                  launchName: launchMasterObject?.attributes?.launchName,
                  launchCategory: launchMasterObject?.attributes?.launchCat,
                  launchMonth: launchMasterObject?.attributes?.launchMonth,
                  launchDrop: launchMasterObject?.attributes?.launchDrop,
                  launchDate: launchMasterObject?.attributes?.launchDate,
                };
              },
            );
        }

        let indentSheetsObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.indent_sheets?.data
            ?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.indent_sheets
              ?.data,
          );
          indentSheetsObjArray =
            entry?.attributes?.core_product?.data?.attributes?.indent_sheets?.data?.map(
              (indentSheetObject) => {
                console.log(indentSheetObject);
                return {
                  indentRefId: indentSheetObject?.id,
                  indentReffName:
                    indentSheetObject?.attributes?.Indent_file_reference_id,
                  indentRefLink:
                    indentSheetObject?.attributes?.Indent_file_link,
                  indentDate: indentSheetObject?.attributes?.indent_file_date,
                  indentType: indentSheetObject?.attributes?.indent_type,
                };
              },
            );
        }

        let techpacksObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.techpacks?.data
            ?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.techpacks?.data,
          );
          techpacksObjArray =
            entry?.attributes?.core_product?.data?.attributes?.techpacks?.data?.map(
              (techpackObj) => {
                console.log(techpackObj);
                return {
                  techpackRefId: techpackObj?.id,
                  techpackReffName:
                    techpackObj?.attributes?.techpack_file_reference_id,
                  techpackRefLink: techpackObj?.attributes?.techpack_file_link,
                  techpackDate: techpackObj?.attributes?.techpack_file_date,
                  techpackSKU: techpackObj?.attributes?.sku,
                };
              },
            );
        }

        // Catalog Requirement
        let subColorObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.sub_color_lists
            ?.data?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.sub_color_lists
              ?.data,
          );
          subColorObjArray =
            entry?.attributes?.core_product?.data?.attributes?.sub_color_lists?.data?.map(
              (subColorObj) => {
                const {
                  id: id = null,
                  attributes: {
                    subColorName = null,
                    filter_color: filterColorObj = null,
                  },
                } = subColorObj;

                const {
                  id: filterColorId = null,
                  attributes: { filter_color_name = null } = {},
                } = filterColorObj?.data ?? {};
                console.log(
                  'sub color details destructures',
                  subColorObj,
                  id,
                  subColorName,
                  filterColorId,
                  filter_color_name,
                );
                return {
                  subColorRefId: id,
                  subColorName: subColorName,
                  filterColorId,
                  filterColorName: filter_color_name,
                };
              },
            );
        }

        // Catalog Requirement
        let fitObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.fits_list?.data
            ?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.fits_list?.data,
          );
          fitObjArray =
            entry?.attributes?.core_product?.data?.attributes?.fits_list?.data?.map(
              (fitObj) => {
                console.log(fitObj);
                return {
                  fitRefId: fitObj?.id,
                  fitName: fitObj?.attributes?.fit_name,
                };
              },
            );
        }

        let supplierDetails = {};
        if (
          entry?.attributes?.core_product?.data?.attributes?.supplier_master
        ) {
          let supplierObject =
            entry?.attributes?.core_product?.data?.attributes?.supplier_master;
          supplierDetails = {
            //productCat -> product option type, example: shirt, crew, pants, etc
            supplierRefId: supplierObject?.data?.id,
            supplierName: supplierObject?.data?.attributes?.supplierName,
          };
        }

        let garmentSpecialAttributesObjectArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes
            ?.garment_special_attributes?.data?.length > 0
        ) {
          garmentSpecialAttributesObjectArray =
            entry?.attributes?.core_product?.data?.attributes?.garment_special_attributes?.data?.map(
              (specialAttriObject) => {
                console.log('garment Special Attribute : ', specialAttriObject);
                return {
                  garmentSpecialAttributeRefId: specialAttriObject?.id,
                  garmentSpecialAttributeName:
                    specialAttriObject?.attributes?.specialAttribute_name,
                };
              },
            );
        }

        let garmentSpecialAttributes2ObjectArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes
            ?.garment_special_attributes2?.data?.length > 0
        ) {
          garmentSpecialAttributes2ObjectArray =
            entry?.attributes?.core_product?.data?.attributes?.garment_special_attributes2?.data?.map(
              (specialAttriObject) => {
                console.log(
                  'garment Special Attribute2 : ',
                  specialAttriObject,
                );
                return {
                  garmentSpecialAttributeRefId: specialAttriObject?.id,
                  garmentSpecialAttributeName:
                    specialAttriObject?.attributes?.specialAttribute_name,
                };
              },
            );
        }

        // Catalog Requirement
        let sizeObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.size_list?.data
            ?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.size_list?.data,
          );
          sizeObjArray =
            entry?.attributes?.core_product?.data?.attributes?.size_list?.data?.map(
              (sizeObj) => {
                console.log(sizeObj);
                return {
                  sizeRefId: sizeObj?.id,
                  sizeName: sizeObj?.attributes?.size_name,
                };
              },
            );
        }

        let specialAttrObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.special_attributes
            ?.data?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes
              ?.special_attributes?.data,
          );
          specialAttrObjArray =
            entry?.attributes?.core_product?.data?.attributes?.special_attributes?.data?.map(
              (specialAttrObj) => {
                console.log(specialAttrObj);
                return {
                  specialAttrRefId: specialAttrObj?.id,
                  specialAttrName:
                    specialAttrObj?.attributes?.specialAttribute_name,
                };
              },
            );
        }

        let silhouetteObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.silhouettes?.data
            ?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.silhouettes
              ?.data,
          );
          silhouetteObjArray =
            entry?.attributes?.core_product?.data?.attributes?.silhouettes?.data?.map(
              (silhouetteObj) => {
                console.log(silhouetteObj);
                return {
                  silhouetteRefId: silhouetteObj?.id,
                  silhouetteName: silhouetteObj?.attributes?.silhouette_name,
                };
              },
            );
        }

        let trendObjArray = [];
        if (
          entry?.attributes?.trends?.core_product?.data?.attributes?.data
            ?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.trends?.data,
          );
          trendObjArray =
            entry?.attributes?.core_product?.data?.attributes?.trends?.data?.map(
              (trendObj) => {
                console.log(trendObj);
                return {
                  trendRefId: trendObj?.id,
                  trendName: trendObj?.attributes?.trend_name,
                };
              },
            );
        }

        // Catalog Requirement
        let productOptionTypeObject = {};
        if (
          entry?.attributes?.core_product?.data?.attributes?.product_option_type
        ) {
          let productOptionType =
            entry?.attributes?.core_product?.data?.attributes
              ?.product_option_type;
          productOptionTypeObject = {
            //productCat -> product option type, example: shirt, crew, pants, etc
            productCatRefId: productOptionType?.data?.id,
            productCatName:
              productOptionType?.data?.attributes?.productCategoryName,
          };
        }

        let planningProductOptionTypeObject = {};
        if (
          entry?.attributes?.core_product?.data?.attributes
            ?.planning_prod_optn_type
        ) {
          let productOptionType =
            entry?.attributes?.core_product?.data?.attributes
              ?.planning_prod_optn_type;
          planningProductOptionTypeObject = {
            //productCat -> product option type, example: shirt, crew, pants, etc
            productCatRefId: productOptionType?.data?.id,
            productCatName:
              productOptionType?.data?.attributes?.productCategoryName,
          };
        }

        let planningProductSubCatObject = {};
        if (
          entry?.attributes?.core_product?.data?.attributes
            ?.planning_prod_sub_cat
        ) {
          let productSubCat =
            entry?.attributes?.core_product?.data?.attributes
              ?.planning_prod_sub_cat;
          planningProductSubCatObject = {
            //productCat -> product option type, example: shirt, crew, pants, etc
            productCatRefId: productSubCat?.data?.id,
            productCatName: productSubCat?.data?.attributes?.sub_category_name,
          };
        }
        // Catalog Requirement
        let designSeasonObj = {};
        if (entry?.attributes?.core_product?.data?.attributes?.design_season) {
          let designSeason =
            entry?.attributes?.core_product?.data?.attributes?.design_season;
          console.log(designSeason);
          designSeasonObj = {
            designSeasonRefId: designSeason?.data?.id,
            designSeasonName: designSeason?.data?.attributes?.season_id,
          };
        }

        // Catalog Requirement
        let launchSeasonObj = {};
        if (entry?.attributes?.core_product?.data?.attributes?.launch_season) {
          let launchSeason =
            entry?.attributes?.core_product?.data?.attributes?.launch_season;
          console.log(launchSeason);
          launchSeasonObj = {
            launchSeasonRefId: launchSeason?.data?.id,
            launchSeasonName: launchSeason?.data?.attributes?.season_id,
          };
        }

        // Catalog Requirement
        let colorFamilyObj = {};
        if (entry?.attributes?.core_product?.data?.attributes?.color_family) {
          let color =
            entry?.attributes?.core_product?.data?.attributes?.color_family;
          console.log(color, 'Color Family in core product details');
          colorFamilyObj = {
            colorFamilyRefId: color?.data?.id,
            colorFamilyName: color?.data?.attributes?.subColorName,
          };
        }

        let ppBracketObj = {};
        if (entry?.attributes?.core_product?.data?.attributes?.pp_bracket) {
          let ppBracket =
            entry?.attributes?.core_product?.data?.attributes?.pp_bracket;
          console.log(ppBracket, 'ppBracket Family in core product details');
          ppBracketObj = {
            ppBracketRefId: ppBracket?.data?.id,
            ppBracketName: ppBracket?.data?.attributes?.pp_bracket_name,
          };
        }

        let patternObjArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.patterns?.data
            ?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.patterns?.data,
            'patterns core product details',
          );
          patternObjArray =
            entry?.attributes?.core_product?.data?.attributes?.patterns?.data?.map(
              (patternObj) => {
                console.log(patternObj);
                return {
                  patternRefId: patternObj?.id,
                  patternName: patternObj?.attributes?.patternName,
                };
              },
            );
        }

        // Catalog Requirement
        let productVariantArray = [];
        if (
          entry?.attributes?.core_product?.data?.attributes?.product_variants
            ?.data?.length > 0
        ) {
          console.log(
            entry?.attributes?.core_product?.data?.attributes?.product_variants
              ?.data,
          );
          productVariantArray =
            entry?.attributes?.core_product?.data?.attributes?.product_variants?.data?.map(
              (productVariantObject) => {
                console.log('product variants', productVariantObject);
                return {
                  variantRefId: productVariantObject?.id,
                  variantSKU: productVariantObject?.attributes?.variant_sku,
                  variantSize: productVariantObject?.attributes?.size,
                  variantSubColor: productVariantObject?.attributes?.sub_color,
                  variantFit: productVariantObject?.attributes?.fit,
                  variantCost: productVariantObject?.attributes?.cost,
                  variantMrp: productVariantObject?.attributes?.mrp,
                };
              },
            );
        }

        // Catalog Requirement
        let washcareDetails = {};
        if (entry?.attributes?.core_product?.data?.attributes?.washcare) {
          let washcareObject =
            entry?.attributes?.core_product?.data?.attributes?.washcare;
          washcareDetails = {
            //productCat -> product option type, example: shirt, crew, pants, etc
            washcareRefId: washcareObject?.data?.id,
            washcareInstruction:
              washcareObject?.data?.attributes?.washcare_instruction,
            washcareType: washcareObject?.data?.attributes?.washcare_type,
          };
        }

        const data1 = {
          key: entry?.id,
          id: entry?.id,
          coreProductId: entry?.attributes?.core_product?.data?.id,
          catalogingStatus: entry.attributes?.cataloging_status,
          month: entry?.attributes?.core_product?.data?.attributes?.month,
          launchDrop:
            entry?.attributes?.core_product?.data?.attributes?.launchDrop,
          category: productOptionTypeObject?.productCatName,
          quantity: entry?.attributes?.core_product?.data?.attributes?.qty,

          sleeve: entry?.attributes?.core_product?.data?.attributes?.Sleeve,

          amrp: entry?.attributes?.core_product?.data?.attributes?.amrp,
          assumedMRP:
            entry?.attributes?.core_product?.data?.attributes?.assumedMRP,

          description:
            entry?.attributes?.core_product?.data?.attributes?.description,

          sku: entry?.attributes?.core_product?.data?.attributes?.sku,

          proj_disc:
            entry?.attributes?.core_product?.data?.attributes?.proj_disc,
          cogs: entry?.attributes?.core_product?.data?.attributes?.cogs,
          total_cogs:
            entry?.attributes?.core_product?.data?.attributes?.total_cogs,
          cogs_percentage:
            entry?.attributes?.core_product?.data?.attributes?.cogs_percentage,
          pp_slab: entry?.attributes?.core_product?.data?.attributes?.pp_slab,
          pp_bracket: ppBracketObj?.ppBracketRefId,
          asp: entry?.attributes?.core_product?.data?.attributes?.asp,
          supplier_master: supplierDetails,

          arv: entry?.attributes?.core_product?.data?.attributes?.arv,
          total_arv:
            entry?.attributes?.core_product?.data?.attributes?.total_arv,
          target_cogs:
            entry?.attributes?.core_product?.data?.attributes?.target_cogs,
          lifeOccasion:
            entry?.attributes?.core_product?.data?.attributes?.lifeOccasion,
          weight: entry?.attributes?.core_product?.data?.attributes?.weight,
          color_depth:
            entry?.attributes?.core_product?.data?.attributes?.color_depth,
          gsm: entry?.attributes?.core_product?.data?.attributes?.gsm,

          knit_woven:
            entry?.attributes?.core_product?.data?.attributes?.knit_woven,
          freshness:
            entry?.attributes?.core_product?.data?.attributes?.freshness,
          fabric_special_attribute:
            entry?.attributes?.core_product?.data?.attributes
              ?.fabric_special_attribute,

          icons: entry?.attributes?.core_product?.data?.attributes?.icons,

          feature1: entry?.attributes?.core_product?.data?.attributes?.feature1,
          feature2: entry?.attributes?.core_product?.data?.attributes?.feature2,
          feature3: entry?.attributes?.core_product?.data?.attributes?.feature3,
          designCategory:
            entry?.attributes?.core_product?.data?.attributes?.designCategory,
          po_price: entry?.attributes?.core_product?.data?.attributes?.po_price,
          payment_modal:
            entry?.attributes?.core_product?.data?.attributes?.payment_modal,
          cost_of_finance:
            entry?.attributes?.core_product?.data?.attributes?.cost_of_finance,
          garment_weight:
            entry?.attributes?.core_product?.data?.attributes?.garment_weight,
          fit_disclaimer:
            entry?.attributes?.core_product?.data?.attributes?.fit_disclaimer,

          // --------------
          merch_complete_date:
            entry?.attributes?.core_product?.data?.attributes
              ?.merch_complete_date,
          planning_complete_date:
            entry?.attributes?.core_product?.data?.attributes
              ?.planning_complete_date,
          design_complete_date:
            entry?.attributes?.core_product?.data?.attributes
              ?.design_complete_date,
          // --------------

          pattern: patternObjArray,

          launchDetails: launchObj,
          productOptionType: productOptionTypeObject,
          planningProductSubCat: planningProductSubCatObject,
          planningProductOptionType: planningProductOptionTypeObject,
          designSeason: designSeasonObj,
          launchSeason: launchSeasonObj,
          colorFamily: colorFamilyObj,
          indentSheetDetails: indentSheetsObjArray,
          techpackDetails: techpacksObjArray,
          colorVariantDetails: subColorObjArray,
          sizeVariantDetails: sizeObjArray,
          fitVariantDetails: fitObjArray,
          silhouetteDetails: silhouetteObjArray,
          trendDetails: trendObjArray,
          specialAttributeDetails: specialAttrObjArray,
          garmentSpecialAttributesDetails: garmentSpecialAttributesObjectArray,
          garmentSpecialAttributes2Details:
            garmentSpecialAttributes2ObjectArray,
          productVariantDetails: productVariantArray,
          status: entry?.attributes?.status,
          object_status: entry?.attributes?.object_status,
          object_status_no: entry?.attributes?.object_status_no,
          catalog_status: entry?.attributes?.cataloging_status,

          washcareDetails: washcareDetails,
          channelInfo: channelObjArray,
          shopifyProduct: shopifyProductObjectObj,
        };

        //---------map end
        // });

        console.log('original Data CORE PRODUCT:', responseData);
        console.log('current Data CORE PRODUCT after modification:', data1);
        // return data1;
        setCoreProductData(data1);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSeasonList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/seasons?sort[0]=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          seasonId: entry?.attributes?.season_id,
        };
      });

      setSeasonMastersList(optionsData2);
      console.log('original season option  Data:', optionsData);
      console.log('modified season Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLaunchList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/launch-masters?&populate[season][fields][0]=season_id&createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          launchName: entry?.attributes?.launchName,
          launchDate: entry?.attributes?.launchDate,
          launchDrop: entry?.attributes?.launchDrop,
          //   launchCat: entry?.attributes?.launchCat,

          seasonName: entry?.attributes?.season?.data?.attributes?.season_id,
          seasonRefId: entry?.attributes?.season?.data?.id,
          // launch_masters: entry?.attributes?.launch_masters,
        };
      });

      setLaunchMastersList(optionsData2);
      console.log('original option Data:', optionsData);
      console.log('modified Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchFitList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/fits?sort[0]=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          fitName: entry?.attributes?.fit_name,
        };
      });

      setFitList(optionsData2);
      console.log('original fit option Data:', optionsData);
      console.log('modified fit Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSizeList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/sizes?sort[0]=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          sizeName: entry?.attributes?.size_name,
        };
      });

      setSizeList(optionsData2);
      console.log('original Size option Data:', optionsData);
      console.log('modified Size Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchColorList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/sub-colors?sort[0]=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          colorName: entry?.attributes?.subColorName,
        };
      });

      setColorList(optionsData2);
      console.log('original color option Data:', optionsData);
      console.log('modified color Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchFamilyColorList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/color-families?sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          colorName: entry?.attributes?.colorName,
        };
      });

      setFamilyColorList(optionsData2);
      console.log('original color family option Data:', optionsData);
      console.log('modified color family Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // not catalog requirement
  const fetchFilterColorList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/filter-colors?sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          filterColorName: entry?.attributes?.filter_color_name,
        };
      });

      setFilterColorList(optionsData2);
      console.log('original color filter group option Data:', optionsData);
      console.log('modified color filter Group option Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // --Silihouettes // not catalog requirement
  const fetchSilhouetteList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/silhouettes?sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          silhouetteName: entry?.attributes?.silhouette_name,
        };
      });

      setSilhouetteList(optionsData2);
      console.log('original Silhouette option Data:', optionsData);
      console.log('modified Silhouette Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // Special Attribute
  // not catalog requirement
  const fetchSpecialAttributeList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/special-attributes?sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          specialAttributeName: entry?.attributes?.specialAttribute_name,
        };
      });

      setSpecialAttributeList(optionsData2);
      console.log('original SpecialAttribute option Data:', optionsData);
      console.log('modified SpecialAttribute Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // trends
  // not catalog requirement
  const fetchTrendList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/trends?sort[0]=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          trendName: entry?.attributes?.trend_name,
        };
      });

      setTrendList(optionsData2);
      console.log('original trends option Data:', optionsData);
      console.log('modified trend Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // Pattern
  // not catalog requirement
  const fetchPatternList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/patterns?sort[0]=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          patternName: entry?.attributes?.patternName,
        };
      });

      setPatternList(optionsData2);
      console.log('original Patterns option Data:', optionsData);
      console.log('modified Pattern Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // catalog requirement
  const fetchProductTypeList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/product-option-types?filters[$and][0][status][$ne]=disabled&filters[$and][1][status][$ne]=deleted&populate[sizes][populate]=true&createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        let sizeObjectArray = [];
        if (entry?.attributes?.sizes?.data?.length > 0) {
          console.log(entry.attributes?.sizes?.data);
          sizeObjectArray = entry?.attributes?.sizes?.data?.map((sizeObj) => {
            console.log(sizeObj);
            return {
              sizeRefId: sizeObj?.id,
              sizeName: sizeObj?.attributes?.size_name,
            };
          });
        }

        const productCategoryObject = {};
        if (entry?.attributes?.product_sub_category?.data?.id) {
          let productCatObj = entry?.attributes?.product_sub_category?.data;
          productCategoryObject.id = productCatObj?.id;
          productCategoryObject.productCategoryName =
            productCatObj?.attributes?.sub_category_name;
        }

        return {
          id: entry?.id,
          productCategoryName: entry?.attributes?.productCategoryName,
          productLifeOccasion: entry?.attributes?.lifeOccasion,
          productSizes: sizeObjectArray,
          productCategory: productCategoryObject,
        };
      });

      setProductTypeList(optionsData2);
      console.log('original Product Type Data:', optionsData);
      console.log('modified Product type Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // catalog requirement may be
  const fetchProductCategoryList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/product-sub-categories?filters[$and][0][status][$ne]=disabled&filters[$and][1][status][$ne]=deleted&sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          productCategoryName: entry?.attributes?.sub_category_name,
        };
      });

      setProductCategoryList(optionsData2);
      console.log('original Product Type Data:', optionsData);
      console.log('modified Product type Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // catalog requirement may be
  const fetchShopifyProductTypeList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/shopify-product-types?filters[$and][0][status][$ne]=disabled&filters[$and][1][status][$ne]=deleted&sort[0]=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        },
      );
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          product_type: entry?.attributes?.product_type,
          product_taxanomy_path: entry?.attributes?.product_taxanomy_path,
        };
      });

      setShopifyProductTypeList(optionsData2);
      console.log('original Shopify Product Type Data:', optionsData);
      console.log('modified Shopify Product type Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // not catalog requirement
  const fetchSupplierList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/suppler-masters?createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          supplierName: entry?.attributes?.supplierName,
          supplierType: entry?.attributes?.supplierType,
        };
      });

      setSupplierList(optionsData2);
      console.log('original Supplier master Data:', optionsData);
      console.log('modified Supplier master Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  // not catalog requirement
  const fetchWashcareList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/washcares?createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData?.data?.map((entry) => {
        return {
          id: entry?.id,
          washcareType: entry?.attributes?.washcare_type,
          washcareInstruction: entry?.attributes?.washcare_instruction,
        };
      });

      setWashcareList(optionsData2);
      console.log('original washcare Data:', optionsData);
      console.log('modified washcare Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log(location, 'line no 40');
    setIsLoading(true);

    fetchLaunchList(authToken);
    fetchSeasonList(authToken);

    fetchWashcareList(authToken);
    fetchProductTypeList(authToken);
    fetchProductCategoryList(authToken);
    fetchShopifyProductTypeList(authToken);

    fetchSupplierList(authToken);
    fetchColorList(authToken);
    fetchFamilyColorList(authToken);
    fetchFilterColorList(authToken);

    fetchFitList(authToken);
    fetchSizeList(authToken);

    fetchSpecialAttributeList(authToken);
    // fetchSilhouetteList(authToken);
    fetchTrendList(authToken);
    fetchPatternList(authToken);

    // setDerivedAttributes(true);

    if (location.state === null) {
    } else {
      console.log('prev page: ', location?.prevPage);
      fetchCoreProductDetails(authToken, location?.state?.id);
      if (location?.state?.prevPage === 'all-product-list') {
        setIsEditable(false);
      }
    }
    setIsLoading(false);
  }, []); // setting the required data for the form based on edit / create request.

  // not catalog requirement
  const getAllowedSilhoutte = async (productOptionTypRefId) => {
    // get details from db and related silhoutte allowed for sub category type of product option type.
    // set it as silhoutte list array in state and it will be reflected in the dropdown as only allowed silhoutte option

    let optionsData2 = [];
    // setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/product-option-types/${productOptionTypRefId}?populate[product_sub_category][populate][silhouettes]=true`,
        {
          headers: { Authorization: `${BEARER} ${getToken()}` },
        },
      );
      const optionsData = await response.json();

      console.log('11original allowed silhoutte Data:', optionsData);

      let allowedSilhoutteData =
        optionsData?.data?.attributes?.product_sub_category?.data?.attributes
          ?.silhouettes;

      console.log('good -- ', allowedSilhoutteData);
      // if(11original allowed silhoutte Data)
      optionsData2 =
        allowedSilhoutteData?.data?.map((entry) => {
          return {
            id: entry?.id,
            silhouetteName: entry?.attributes?.silhouette_name,
          };
        }) ?? [];

      setSilhouetteList(optionsData2);
      console.log('original allowed silhoutte Data:', optionsData);
      console.log('modified allowed silhoutte Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      // setIsLoading(false);
    }

    return optionsData2;
  };
  // set Core Product Details

  useEffect(() => {
    if (coreProductData) {
      let allowedSilhoutte = getAllowedSilhoutte(
        coreProductData?.productOptionType?.productCatRefId,
      );

      console.log('new selected silhoutte funct', allowedSilhoutte);
      // setSilhouetteList(allowedSilhoutte);
    }
  }, [coreProductData]);

  useEffect(() => {
    console.log('Core Product Data based ', coreProductData);
    // setting the form data based on the core product details in case of edit form
    if (coreProductData && coreProductData?.id && silhouetteList) {
      console.log('in Core Product use effect ', coreProductData);

      setIsLoading(true);
      // not catalog requirement

      setVariantList(
        coreProductData?.productVariantDetails?.map((variantInfo) => {
          return {
            variantRefId: variantInfo.variantRefId,
            variantSKU: variantInfo.variantSKU,
          };
        }) || [],
      );

      console.log(
        coreProductData?.sizeVariantDetails?.map((size) => size?.sizeRefId)
          ?.length > 0
          ? coreProductData?.sizeVariantDetails?.map((size) => size?.sizeRefId)
          : false
            ? 'true hai'
            : productTypeList
                ?.filter((productType) => {
                  console.log('in size setting', productTypeList, productType);
                  return (
                    productType.id ==
                    coreProductData?.productOptionType?.productCatRefId
                  );
                })[0]
                ?.productSizes?.map((size) => size?.sizeRefId),
        'checkoooo',
      );

      // setting the form data based on the core product details in case of edit form and also setting the dropdown options based on the existing data for better UX
      setEditData({
        // Catalog requirements
        month: coreProductData?.month,
        launchDrop: coreProductData?.launchDrop,
        qty: coreProductData?.quantity?.toString(),

        Sleeve: coreProductData?.sleeve,

        description: coreProductData?.description,

        // Catalog requirements
        sku: coreProductData?.sku,

        // Catalog requirements
        // Catalog Attributes -----
        handle: coreProductData?.shopifyProduct?.shopifyProductObjectHandle,
        title: coreProductData?.shopifyProduct?.shopifyProductObjectTitle,
        body_html:
          coreProductData?.shopifyProduct?.shopifyProductObjectBodyHtml,
        vendor: coreProductData?.shopifyProduct?.shopifyProductObjectVendor,
        published:
          coreProductData?.shopifyProduct?.shopifyProductObjectPublished,
        product_type:
          coreProductData?.shopifyProduct?.shopifyProductObjectProductType ||
          coreProductData?.shopifyProduct?.product_type,
        product_category:
          coreProductData?.shopifyProduct?.shopifyProductObjectProductCatagory,
        option1_name:
          coreProductData?.shopifyProduct?.shopifyProductObjectOption1Name ||
          coreProductData?.shopifyProduct?.option1_name,
        option2_name:
          coreProductData?.shopifyProduct?.shopifyProductObjectOption2Name ||
          coreProductData?.shopifyProduct?.option2_name,
        option3_name:
          coreProductData?.shopifyProduct?.shopifyProductObjectOption3Name ||
          coreProductData?.shopifyProduct?.option3_name,
        collection:
          coreProductData?.shopifyProduct?.shopifyProductObjectCollection ||
          coreProductData?.shopifyProduct?.collection,

        fabric:
          coreProductData?.shopifyProduct?.shopifyProductObjectFabric ||
          coreProductData?.shopifyProduct?.fabric,
        knit_type:
          coreProductData?.shopifyProduct?.shopifyProductObjectKnitType ||
          coreProductData?.shopifyProduct?.knit_type,
        life_occasion:
          coreProductData?.shopifyProduct?.shopifyProductObjectLifeOccasion ||
          coreProductData?.shopifyProduct?.life_occasion,
        material:
          coreProductData?.shopifyProduct?.shopifyProductObjectMaterial ||
          coreProductData?.shopifyProduct?.material,
        material_care:
          coreProductData?.shopifyProduct?.shopifyProductObjectMaterialCare ||
          coreProductData?.shopifyProduct?.material_care,
        model_info:
          coreProductData?.shopifyProduct?.shopifyProductObjectModelInfo ||
          coreProductData?.shopifyProduct?.model_info,
        sleeves:
          coreProductData?.shopifyProduct?.shopifyProductObjectSleeves ||
          coreProductData?.shopifyProduct?.sleeves,
        weight:
          coreProductData?.shopifyProduct?.shopifyProductObjectWeight ||
          coreProductData?.shopifyProduct?.weight,
        pattern:
          coreProductData?.shopifyProduct?.shopifyProductObjectPattern ||
          coreProductData?.shopifyProduct?.pattern,
        weave_structure:
          coreProductData?.shopifyProduct?.shopifyProductObjectWeaveStructure ||
          coreProductData?.shopifyProduct?.weave_structure,
        length:
          coreProductData?.shopifyProduct?.shopifyProductObjectLength ||
          coreProductData?.shopifyProduct?.length,
        hem:
          coreProductData?.shopifyProduct?.shopifyProductObjectHem ||
          coreProductData?.shopifyProduct?.hem,
        placket:
          coreProductData?.shopifyProduct?.shopifyProductObjectPlacket ||
          coreProductData?.shopifyProduct?.placket,
        cuff:
          coreProductData?.shopifyProduct?.shopifyProductObjectCuff ||
          coreProductData?.shopifyProduct?.cuff,
        launch_name:
          coreProductData?.shopifyProduct?.shopifyProductObjectLaunchName ||
          coreProductData?.shopifyProduct?.launch_name,
        launch_date:
          (coreProductData?.shopifyProduct?.shopifyProductObjectLaunchDate &&
            moment(
              coreProductData?.shopifyProduct?.shopifyProductObjectLaunchDate,
            )) ||
          (coreProductData?.shopifyProduct?.launch_date &&
            moment(coreProductData?.shopifyProduct?.launch_date)) ||
          null,
        launch_season:
          (coreProductData?.shopifyProduct?.shopifyProductObjectLaunchSeason || coreProductData?.shopifyProduct?.launch_season) ||
          null,
        shopify_product_variants:
          typeof coreProductData?.shopifyProduct
            ?.shopifyProductObjectShopifyProductVariants === 'string'
            ? coreProductData?.shopifyProduct
                ?.shopifyProductObjectShopifyProductVariants
            : JSON.stringify(
                coreProductData?.shopifyProduct
                  ?.shopifyProductObjectShopifyProductVariants,
                null,
                2,
              ) ||
              (typeof coreProductData?.shopifyProduct
                ?.shopify_product_variants === 'string'
                ? coreProductData?.shopifyProduct?.shopify_product_variants
                : JSON.stringify(
                    coreProductData?.shopifyProduct?.shopify_product_variants,
                    null,
                    2,
                  )),
        tags: coreProductData?.shopifyProduct?.shopifyProductObjectTags,
        seo_title:
          coreProductData?.shopifyProduct?.shopifyProductObjectSeoTitle,
        seo_description:
          coreProductData?.shopifyProduct?.shopifyProductObjectSeoDescription,
        color_group_id:
          coreProductData?.shopifyProduct?.shopifyProductObjectColorGroupId,
        color_group_ref:
          coreProductData?.shopifyProduct?.shopifyProductObjectColorGroupRef,
        color_variants:
          coreProductData?.shopifyProduct?.shopifyProductObjectColorVariants,
        complementary:
          coreProductData?.shopifyProduct?.shopifyProductObjectComplementary,
        country_manufacture:
          coreProductData?.shopifyProduct
            ?.shopifyProductObjectCountryManufacture,
        country_of_manufacture:
          coreProductData?.shopifyProduct
            ?.shopifyProductObjectCountryOfManufacture,

        cuff:
          coreProductData?.shopifyProduct?.cuff ||
          coreProductData?.shopifyProduct?.cuff_details,
        hero_product:
          coreProductData?.shopifyProduct?.shopifyProductObjectHeroProduct,
        cohort_remarks_1:
          coreProductData?.shopifyProduct?.shopifyProductObjectCohortRemarks1,
        cohort_remarks_2:
          coreProductData?.shopifyProduct?.shopifyProductObjectCohortRemarks2,
        cohort_remarks_3:
          coreProductData?.shopifyProduct?.shopifyProductObjectCohortRemarks3,
        shopify_status:
          coreProductData?.shopifyProduct?.shopifyProductObjectShopifyStatus,

        cataloging_status: coreProductData?.catalogingStatus,

        // Catalog requirements
        status: coreProductData?.status,
        object_status_no: coreProductData?.object_status_no,
        object_status: coreProductData?.object_status,
        launch_masters: coreProductData?.launchDetails?.map(
          (launch) => launch.launchRefId,
        ),

        //not catalog requirement
        patterns: coreProductData?.pattern?.map(
          (pattern) => pattern?.patternRefId,
        ),
        // catalog requirement

        shopify_product_type:
          coreProductData?.shopifyProduct
            ?.shopifyProductObjectShopifyProductTypeId,

        // Catalog requirements
        product_option_type:
          coreProductData?.productOptionType?.productCatRefId,

        // catalog requirement
        sub_color_lists: coreProductData?.colorVariantDetails?.map(
          (subColor) => subColor?.subColorRefId,
        ),
        // catalog requirement
        filter_color: coreProductData?.colorVariantDetails?.map(
          (subColor) => subColor?.filterColorId,
        ),

        // catalog requirement
        fits_list: coreProductData?.fitVariantDetails?.map(
          (fit) => fit?.fitRefId,
        ),
        // catalog requirement
        size_list:
          coreProductData?.sizeVariantDetails?.map((size) => size?.sizeRefId)
            ?.length > 0
            ? coreProductData?.sizeVariantDetails?.map(
                (size) => size?.sizeRefId,
              )
            : false
              ? 'true hai'
              : productTypeList
                  ?.filter((productType) => {
                    console.log(
                      'in size setting',
                      productTypeList,
                      productType,
                    );
                    return (
                      productType.id ==
                      coreProductData?.productOptionType?.productCatRefId
                    );
                  })[0]
                  ?.productSizes?.map((size) => size?.sizeRefId),
        // not catalog requirement

        editId: coreProductData?.id,
        coreProductId: coreProductData?.coreProductId,
      });

      coreProductData?.launchDetails?.launchRefId &&
        setSelectedLaunchNew(coreProductData?.launchDetails?.launchRefId); // for selecting related launch details in the form
    }

    setIsLoading(false);
  }, [coreProductData, silhouetteList]);

  useEffect(() => {
    // setting the form fields based on the edit data which is set based on the core product details in case of edit form
    console.log(editData, dataform, '121');
    setIsLoading(true);
    dataform.setFieldsValue(editData);
    setIsLoading(false);
  }, [editData, dataform]); // set form fields on change in editdata or dataform.

  // useEffect(() => {
  //   if (derivedAttributes) {
  //     console.log(
  //       'automationTesting',
  //       location?.state?.designSeason,
  //       location?.state?.designSeason?.designSeasonRefId,
  //       location?.state?.launchDetails,
  //       location?.state?.launchDetails?.launchRefId,
  //       launchMastersList
  //     );
  //   }
  // }, [derivedAttributes]);

  if (isLoading1) {
    return <Spin size="large" />;
  }

  const checkMandatoryFields = (data) => {
    const errorFieldList = [];
    console.log('Mandatory field check data', data, mandatoryFieldsConfig);
    const coreProductFieldObject =
      mandatoryFieldsConfig?.object_type?.core_product;

    console.log('core Product Data', coreProductFieldObject);
    if (
      !coreProductFieldObject &&
      Object.keys(coreProductFieldObject)?.length === 0
    ) {
      return errorFieldList;
    }

    const fieldList = Object.keys(coreProductFieldObject);
    const changedList = Object.keys(updatedValues);
    const attributeList = Object.keys(data?.data || {});
    console.log('Changed List', changedList);
    console.log('field List', fieldList);
    console.log('attribute List', attributeList);

    attributeList.forEach((attribute) => {
      console.log(
        'check attribute',
        coreProductFieldObject[attribute]?.label,
        data?.data[attribute],
      );
      if (changedList.includes(attribute)) {
        if (fieldList.includes(attribute) && !data?.data[attribute]) {
          console.log(
            'error attribute',
            coreProductFieldObject[attribute]?.label,
          );
          errorFieldList.push(coreProductFieldObject[attribute]?.label);
        }
      }
    });
    console.log('error List', errorFieldList);
    return errorFieldList;
  };

  const addNewRecord = async (data) => {
    if (!isEditable) {
      return false;
    }
    setSaving(true);

    console.log('Edit data in add new record', editData);
    // data = editData;
    // design data
    const color_family = data['sub_color_lists'][0];
    console.log('data in add new record', data);

    //planning data
    const qty = parseFloat(data['qty']);
    const amrp = parseFloat(data['amrp']);
    const assumedMRP = parseFloat(data['assumedMRP']);
    const proj_disc = parseFloat(data['proj_disc']);
    const asp = parseFloat(data['asp']);
    const arv = parseFloat(data['arv']);
    const pp_bracket = data['pp_bracket'];
    const productOptionTypeRefId = data['product_option_type'];

    // merchandising data
    const cogs = parseFloat(data['cogs']);
    const total_cogs = parseFloat(data['total_cogs']);
    const po_price = parseFloat(data['po_price']);
    const garment_weight = parseFloat(data['garment_weight']);
    const cost_of_finance = parseFloat(data['cost_of_finance']);
    const cogs_percentage = parseFloat(data['cogs_percentage']);

    // not Catalog requirement

    // catalog requirement
    const shopifyProduct = {
      handle: data['handle'],
      title: data['title'],
      body_html: data['body_html'],
      vendor: data['vendor'],
      published: data['published'],
      tags: data['tags'],
      seo_title: data['seo_title'],
      seo_description: data['seo_description'],
      color_group_id: data['color_group_id'],
      color_group_ref: data['color_group_ref'],
      color_variants: data['color_variants'],
      complementary: data['complementary'],
      country_manufacture: data['country_manufacture'],
      hero_product: data['hero_product'],
      cohort_remarks_1: data['cohort_remarks_1'],
      cohort_remarks_2: data['cohort_remarks_2'],
      cohort_remarks_3: data['cohort_remarks_3'],
      shopify_status: data['shopify_status'],
      shopify_product_type: data['shopify_product_type'],
      product_type: data['product_type'],
      option1_name: data['option1_name'],
      option2_name: data['option2_name'],
      option3_name: data['option3_name'],
      launch_name: data['launch_name'],
      launch_date: data['launch_date'],
      shopify_product_variants: data['shopify_product_variants'],
      country_of_manufacture: data['country_of_manufacture'],
      sleeves: data['sleeves'],
      cuff: data['cuff'],
      product_category: data['product_category'],
      collection: data['collection'],
      fabric: data['fabric'],
      features_specifications: data['features_specifications'],
      knit_type: data['knit_type'],
      life_occasion: data['life_occasion'],
      material: data['material'],
      material_care: data['material_care'],
      model_info: data['model_info'],
      sleeve: data['sleeve'],
      weight: data['weight'],
      pattern: data['pattern'],
      weave_structure: data['weave_structure'],
      length: data['length'],
      hem: data['hem'],
      placket: data['placket'],
      cuff_details: data['cuff_details'],
    };
    // catalog requirement

    delete data['qty'];

    console.log('test data', data);

    // return;
    const values = {
      ...data,
      qty: qty,
      amrp: amrp,
      proj_disc: proj_disc,
      asp: asp,
      arv: arv,
      cogs: cogs,
      total_cogs: total_cogs,
      cost_of_finance: cost_of_finance,
      po_price: po_price,
      garment_weight: garment_weight,
      cogs_percentage: cogs_percentage,
      assumedMRP,
      shopify_product: shopifyProduct,
    };

    console.log('data:', data, color_family);

    data = { data: values };

    console.log('values:', values, data);

    console.log('data edit:', data.data.editId);
    // return;

    if (data.data.editId) {
      console.log('edit id :', data.data.editId);
      console.log('Updated Data :', updatedValues);

      let updatedDataSent = { data: { ...data.data } };
      console.log('updated data sent : ', updatedDataSent);

      const mandatoryFieldsError = checkMandatoryFields({
        data: { ...updatedDataSent.data },
      });

      console.log('Mandatory Field Error List', mandatoryFieldsError);
      if (mandatoryFieldsError?.length > 0) {
        const errorMessageText = mandatoryFieldsError.map((field) => {
          message.error(`Mandatory field "${field}" is missing.`);
          return `Mandatory field "${field}" is missing.`;
        });
        setSaving(false);
        return;
      }
      // return false;
      try {
        const response = await fetch(
          `${API}/core-products/${data.data.editId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',

              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(updatedDataSent),
          },
        );
        const responseData = await response.json();
        console.log('result recived', responseData);
        // return false;
        if (responseData.error) {
          console.log(responseData.error);

          errorHandler(
            responseData,
            message,
            'Unable to Update Record, ' + responseData?.error,
          );
        } else {
          message.success('Data saved successfully!');
          toPreviousPage();
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        setEditData(null);
      }
    } else {
      // create a new record in the database table  -  not allowed as all product will be allready created and avaliable for edit only
      console.log('edit id :', data.editId);

      try {
        const response = await fetch(`${API}/core-products/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        console.log(responseData);
        if (responseData?.error) {
          // message.error('Unable to process your request.');
          errorHandler(
            responseData,
            message,
            'Unable to Update Record, ' + responseData?.error,
          );
        } else {
          message.success('Data saved successfully!');
          toPreviousPage();
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
      }
    }
  };

  const toPreviousPage = () => {
    navigate(-1);
  };

  const toVariantDetailsPage = (variantdetails) => {
    const state = {
      variantId: variantdetails?.variantId,
      variantList: variantdetails?.variantList,
    };
    // console.log(state);
    navigate('/variantProductDetail', { state });
  };

  const launchListOptions = launchMastersList.map((launch) => {
    return {
      label: `${launch.launchName} - ${launch.seasonName} `,
      value: launch.id,
    };
  });

  const seasonListOptions = seasonMastersList.map((season) => {
    return {
      label: season.seasonId,
      value: season.id,
    };
  });

  // console.log(colorList);
  const sizeListOptions = sizeList.map((size) => {
    return {
      label: size.sizeName,
      value: size.id,
    };
  });

  const fitListOptions = fitList.map((fit) => {
    return {
      label: fit.fitName,
      value: fit.id,
    };
  });

  const colorListOptions = colorList.map((color) => {
    return {
      label: color.colorName,
      value: color.id,
    };
  });

  const familyColorListOptions = familyColorList.map((color) => {
    return {
      label: color?.colorName,
      value: color?.id,
    };
  });

  const filterColorListOptions = filterColorList.map((color) => {
    return {
      label: color?.filterColorName,
      value: color?.id,
    };
  });

  const silhouetteListOptions = silhouetteList.map((silhouette) => {
    return {
      label: silhouette?.silhouetteName,
      value: silhouette?.id,
    };
  });

  // options for new dropdown attributes

  const specialAttributeListOptions = specialAttributeList.map(
    (specialAttribute) => {
      return {
        label: specialAttribute?.specialAttributeName,
        value: specialAttribute?.id,
      };
    },
  );

  const trendListOptions = trendList.map((trend) => {
    return {
      label: trend?.trendName,
      value: trend?.id,
    };
  });

  const patternListOption = patternList?.map((pattern) => {
    return {
      label: pattern.patternName,
      value: pattern.id,
    };
  });

  const monthListOptions = monthNames.map((month, index) => {
    return {
      label: month,
      value: month,
    };
  });
  console.log('355', monthListOptions);

  const ProductTypeOptions = productTypeList?.map((productType) => {
    return {
      label: productType.productCategoryName,
      value: productType.id,
    };
  });

  const ProductCategoryOptions = productCategoryList?.map((productType) => {
    return {
      label: productType.productCategoryName,
      value: productType.id,
    };
  });

  const ShopifyProductTypeOptions = shopifyProductTypeList?.map(
    (productType) => {
      return {
        label: productType.product_type,
        value: productType.id,
      };
    },
  );

  const ShopifyProductCatagoryOptions = shopifyProductTypeList?.map(
    (productType) => {
      return {
        label: productType.product_taxanomy_path,
        value: productType.id,
      };
    },
  );

  const SupplierList = supplierList.map((supplier) => {
    return {
      label: `${supplier.supplierName} - ${supplier.supplierType} `,
      value: supplier.id,
    };
  });

  const WashcareOptionList = washcareList?.map((washcare) => {
    return {
      label: `${washcare?.washcareType}`,
      value: washcare?.id,
    };
  });

  const CoreProductStatusList = coreProductStatusList
    .filter((objectStatus) => !objectStatus.hide)
    .map((statusObject) => {
      return {
        label: statusObject.object_status,
        value: statusObject.object_status_no,
      };
    });

  const catalogProductStatusListOption = catalogProductStatusList
    .filter((objectStatus) => !objectStatus.hide)
    .map((statusObject) => {
      return {
        label: statusObject.object_status,
        value: statusObject.object_status,
      };
    });

  const paymentModalOptionList = paymentModelOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const tnaStatusOptionList = tnaStatusOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const sleeveOptionList = sleeveOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const freshnessOptionList = freshnessOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const fabricSpecialAttributeOptionList =
    fabricSpecialAttributeOptionArray.map((value) => {
      return {
        label: toProperCase(value),
        value: value,
      };
    });

  const knitWovenOptionList = knitWovenOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const weightOptionList = weightOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const colorDepthOptionList = colorDepthOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const lifeOccasionOptionList = lifeOccasionOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  const designCategoryOptionList = designCategoryOptionArray.map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  console.log(CoreProductStatusList, 'status list');

  const updateDependentField = (value) => {
    let selectedLaunchArray = [];

    console.log('Updating', value, launchMastersList);
    value.map((launchId) => {
      const selectedLaunch = launchMastersList?.filter((launch) => {
        return launch.id === launchId && launch;
      });
      selectedLaunchArray?.push(...selectedLaunch);
    });

    console.log(selectedLaunchArray);
    setEditData({
      ...editData,
      launch_masters: selectedLaunchArray.map((launch) => launch.id),
      launchDrop: selectedLaunchArray[0]?.launchDrop,
    });
  };

  const handleValuesChange = async (changedValues, allValues) => {
    console.log('Changed values:', changedValues);
    console.log('All values:', allValues);
    // setUpdatedValues({ ...changedValues, ...updatedValues });

    const derivedValues = {};
    if (changedValues) {
      if (changedValues?.po_price || changedValues?.qty) {
        const poPrice =
          parseFloat(changedValues?.po_price) ||
          parseFloat(allValues?.po_price) ||
          0;
        const qty =
          parseFloat(changedValues?.qty) || parseFloat(allValues?.qty) || 0;
        const cof = poPrice * qty;

        derivedValues.cost_of_finance = cof;
        // console.log(cof);
      }

      if (changedValues?.cogs || changedValues?.qty) {
        const cogp =
          parseFloat(changedValues?.cogs) || parseFloat(allValues?.cogs) || 0;
        const qty =
          parseFloat(changedValues?.qty) || parseFloat(allValues?.qty) || 0;

        if (cogp && cogp > 0) {
          const totalcogp = cogp * qty;

          derivedValues.total_cogs = totalcogp;
          // console.log(totalcogp);
        }
      }

      if (
        changedValues?.proj_disc ||
        changedValues?.amrp ||
        changedValues?.product_option_type ||
        changedValues?.qty
      ) {
        const proj_disc =
          parseFloat(changedValues?.proj_disc) ||
          parseFloat(allValues?.proj_disc) ||
          0;
        const qty =
          parseFloat(changedValues?.qty) || parseFloat(allValues?.qty) || 0;
        const amrp =
          parseFloat(changedValues?.amrp) || parseFloat(allValues?.amrp) || 0;

        const cogp =
          parseFloat(changedValues?.cogs) || parseFloat(allValues?.cogs) || 0;
        const auto_asp = amrp - amrp * (proj_disc / 100) || 0;
        const auto_arv = (auto_asp / 112) * 100 || 0;
        const auto_total_arv = qty * auto_arv || 0;
        const auto_cogp_percent = (cogp / auto_arv) * 100 || 0;

        // pp slab calculation on change in any value related to pp slab dependence variable.
        const productOptionType =
          changedValues?.product_option_type || allValues?.product_option_type;
        let designProductCategory = null;

        derivedValues.design_product_category = designProductCategory;
        derivedValues.asp = auto_asp?.toFixed(2)?.toString();
        derivedValues.arv = auto_arv?.toFixed(2)?.toString();
        derivedValues.total_arv = auto_total_arv?.toFixed(2)?.toString();
        derivedValues.cogs_percentage = auto_cogp_percent
          ?.toFixed(2)
          ?.toString();
        console.log('auto calc INPUT:: ', proj_disc, qty, amrp);
        console.log('auto calc:: ', auto_asp, auto_arv, auto_total_arv);
      }

      if (changedValues?.cogs || changedValues?.arv) {
        const cogs =
          parseFloat(changedValues?.cogs) || parseFloat(allValues?.cogs) || 0;
        const arv =
          parseFloat(changedValues?.arv) || parseFloat(allValues?.arv) || 0;

        const auto_cogp_percent = (cogs / arv) * 100 || 0;

        derivedValues.cogs_percentage = auto_cogp_percent
          ?.toFixed(2)
          ?.toString();

        console.log('auto calc INPUT:: ', cogs, arv);
        console.log('auto calc:: ', auto_cogp_percent);
      }

      setUpdatedValues({
        ...changedValues,
        ...updatedValues,
        ...derivedValues,
      });
      setEditData({
        ...allValues,
        ...derivedValues,
        ...changedValues,
      });
    }
  };

  const removeExtraField = (index) => {
    const updatedProductOptionDetails = [...productOptionDetails];
    updatedProductOptionDetails.splice(index, 1);
    setProductOptionDetails(updatedProductOptionDetails);
  }; // not used

  // --------------------Trend master------------

  const showModalTrend = () => {
    setIsModalOpenTrend(true);
    // modalformTrend.setFieldsValue({

    // });
  };

  const handleOkTrend = () => {
    modalformTrend.resetFields();
    setIsModalOpenTrend(false);
  };
  const handleCancelTrend = () => {
    modalformTrend.resetFields();
    setIsModalOpenTrend(false);
  };

  // --------------------Trend master------------

  const addNewEntityTrend = async (data) => {
    setSaving(true);
    const values = {
      ...data,
      core_products: editData?.editId ? editData.editId : null,
      // launch_master: editData?.launch_masters[0]
      //   ? editData?.launch_masters[0]
      //   : null,
    };

    data = { data: values };

    console.log('data:', data);
    console.log('values:', values);

    // return;
    console.log('data edit:', data.data.editEntityId);

    if (data.data.editEntityId) {
      console.log('edit id modal entity :', data.data.editEntityId);

      try {
        const response = await fetch(
          `${API}/trends/${data.data.editEntityId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',

              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(data),
          },
        );
        const responseData = await response.json();
        console.log('result recived', responseData);
        if (responseData.error) {
          message.error('Unable to Update Record, ' + responseData.error);
        } else {
          message.success('Data saved successfully!');
          fetchTrendList(authToken);
          //   toPreviousPage();
          handleOkTrend();
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        // setEditData(null);
      }
    } else {
      // create a new record in the database table
      //   console.log('edit id :', data.editEntityId);

      try {
        const response = await fetch(`${API}/trends/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          message.error('Unable to new Trend');
        } else {
          message.success('Data saved successfully!');
          fetchTrendList(authToken);
          // dataform.setFieldsValue({
          //   trends: [
          //     ...(dataform?.getFieldValue('trends') || []),
          //     responseData?.data?.id,
          //   ],
          // });

          const derivedValues = {};
          derivedValues.trends = [
            ...(dataform?.getFieldValue('trends') || []),
            responseData?.data?.id,
          ];
          setUpdatedValues({
            ...updatedValues,
            ...derivedValues,
          });

          setEditData({
            ...editData,
            trends: [
              ...(dataform?.getFieldValue('trends') || []),
              responseData?.data?.id,
            ],
          });

          handleOkTrend();
          //   toPreviousPage();
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
      }
    }
  };

  const generateVariants = async () => {
    const fields = dataform.getFieldsValue();
    const {
      sub_color_lists,
      fits_list,
      size_list,
      assumedMRP,
      cogs,
      sku,
      editId,
    } = fields;
    console.log(sub_color_lists, fits_list, size_list);
    const variantsDetails = {
      colorsList: sub_color_lists,
      fitsList: fits_list,
      sizeList: size_list,
      mrp: assumedMRP,
      cost: cogs,
      sku: sku,
      catalogProductId: editId,
    };

    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/core-product/generate-variant-products`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            data: { variantsDetails },
          }),
        },
      );
      const responseData = await response.json();
      console.log('variant created', responseData);
      const variantsCreated = responseData?.data?.completeSuccess;
      console.log(variantsCreated);
      // setVariantList(
      //   variantsCreated?.map((variantInfo) => {
      //     console.log(variantInfo);
      //     return {
      //       variantRefId: variantInfo.id,
      //       variantSKU: variantInfo.variant_sku,
      //     };
      //   }) || []
      // );
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        message.success(`Product Variants for ${sku} Successfully Created`);
        toPreviousPage();
        // fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {!coreProductData ? (
        <Spin size="large" />
      ) : (
        <>
          <div className="infoPage_actionButton">
            <Typography.Title level={2}>
              Shopify Product Details
            </Typography.Title>

            <Button type="link" onClick={toPreviousPage}>
              Back
              <RollbackOutlined />
            </Button>
          </div>

          <div>
            <Form
              form={dataform}
              layout="vertical"
              onFinish={addNewRecord}
              onValuesChange={handleValuesChange}
              scrollToFirstError={{
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
              }}
            >
              <Row gutter={[16, 16]}>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    label="Launch Master"
                    name="launch_masters"
                    rules={[
                      {
                        required: true,
                        message: 'Launch is Required!',
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      onSearch={(value) => {
                        // console.log('searching...', value);
                      }}
                      onChange={updateDependentField}
                      placeholder="Select "
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLowerCase()
                          .includes(input.trim().toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={launchListOptions}
                      mode="multiple"
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    label="Month"
                    name="month"
                    rules={[
                      {
                        required: true,
                        message: 'Month is Required!',
                      },
                    ]}
                  >
                    {<Select options={monthListOptions} />}
                    {/*<Input placeholder="Month" />*/}
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <div className="mandatoryMark">
                    <Form.Item
                      label="Product Type/Sub Category"
                      name="product_option_type"
                      rules={[
                        {
                          required: true,
                          message: 'Product sub Category is Required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={ProductTypeOptions}
                      />
                    </Form.Item>
                    <Tooltip title="This is a required Field">
                      <ExclamationCircleTwoTone
                        twoToneColor={mandatoryIconColor}
                      />
                    </Tooltip>
                  </div>
                </Col>

                <Col md={8} lg={8} sm={24} xs={24}>
                  <div className="mandatoryMark">
                    <Form.Item
                      label="Quantity"
                      name="qty"
                      rules={[
                        {
                          // required: true,
                          message: 'Please enter a valid quantity',
                          pattern: '^([0-9]{0,10})$',
                        },
                      ]}
                    >
                      <Input placeholder="Quantity" />
                    </Form.Item>
                    <Tooltip title="This is a required Field">
                      <ExclamationCircleTwoTone
                        twoToneColor={mandatoryIconColor}
                      />
                    </Tooltip>
                  </div>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item label="Status" name="status" initialValue="active">
                    <Select placeholder="Select Status" disabled={true}>
                      <Select.Option value="active">Active</Select.Option>
                      <Select.Option value="inactive">In Active</Select.Option>
                      <Select.Option value="wip">WIP</Select.Option>
                      <Select.Option value="droped">Droped</Select.Option>
                      <Select.Option value="complete">complete</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item label="Product Status" name="object_status_no">
                    <Select
                      disabled={true}
                      placeholder="Select "
                      optionFilterProp="children"
                      options={CoreProductStatusList}
                    />
                  </Form.Item>
                </Col>
                <Divider orientation="left">Variant Information</Divider>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <div className="mandatoryMark">
                    <Form.Item
                      label="Colours"
                      name="sub_color_lists"
                      rules={[
                        {
                          required: true,
                          message: 'Color is Required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={colorListOptions}
                        mode="multiple"
                      />
                    </Form.Item>
                    <Tooltip title="This is a required Field">
                      <ExclamationCircleTwoTone
                        twoToneColor={mandatoryIconColor}
                      />
                    </Tooltip>
                  </div>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <div className="mandatoryMark">
                    <Form.Item
                      label="Fits"
                      name="fits_list"
                      rules={[
                        {
                          required: true,
                          message: 'fit is Required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={fitListOptions}
                        mode="multiple"
                      />
                    </Form.Item>{' '}
                    <Tooltip title="This is a required Field">
                      <ExclamationCircleTwoTone
                        twoToneColor={mandatoryIconColor}
                      />
                    </Tooltip>
                  </div>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    label="Size"
                    name="size_list"
                    // rules={[
                    //   {
                    // required: true,
                    // message: 'size is Required!',
                    //   },
                    // ]}
                  >
                    <Select
                      showSearch
                      onSearch={(value) => {}}
                      placeholder="Select "
                      disabled={
                        !user.rolesAssigned.find(
                          (role) =>
                            userRolesAllowedForAttributes?.edit?.merchAttribute?.includes(
                              role,
                            ) ||
                            userRolesAllowedForAttributes?.edit?.planningAttribute?.includes(
                              role,
                            ),
                        )
                      }
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLowerCase()
                          .includes(input.trim().toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={sizeListOptions}
                      mode="multiple"
                    />
                  </Form.Item>
                </Col>
                {false && variantList?.length === 0 && (
                  <Button
                    type="default"
                    onClick={generateVariants}
                    disabled={
                      !user.rolesAssigned.find((role) =>
                        userRolesAllowedForAttributes.edit.merchAttribute.includes(
                          role,
                        ),
                      )
                    }
                  >
                    Generate Variants
                  </Button>
                )}
                {console.log('variant list', variantList)}
                {variantList.length > 0 && (
                  <div>
                    <ul>
                      {' '}
                      {variantList.map((variant) => {
                        console.log('variant details', variant);
                        return (
                          <li>
                            <a
                              onClick={() => {
                                toVariantDetailsPage({
                                  variantId: variant?.variantRefId,
                                  variantList: variantList,
                                });
                              }}
                            >
                              {variant?.variantSKU}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
                {/* -------cataloging Data----------- */}
                <Divider orientation="left">Shopify Data</Divider>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="handle"
                    label="Product Handle"
                    rules={[
                      {
                        required: true,
                        message: 'Product Handle is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Product Handle" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="title"
                    label="Product Title"
                    rules={[
                      {
                        type: 'string',
                        message: 'Product Title is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Product Title" />
                  </Form.Item>
                </Col>

                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item label="Cataloging Status" name="cataloging_status">
                    <Select
                      disabled={true}
                      placeholder="Select "
                      optionFilterProp="children"
                      options={catalogProductStatusList}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="vendor"
                    label="Vendor"
                    rules={[
                      {
                        type: 'string',
                        message: 'Vendor is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Vendor" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="published"
                    label="Published"
                    rules={[
                      {
                        type: 'boolean',
                        message: 'Published is Required',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Published"
                      options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="body_html"
                    label="Body HTML"
                    rules={[
                      {
                        type: 'string',
                        message: 'Body HTML is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Body HTML" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item name="tags" label="Tags">
                    <Input placeholder="Tags" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="seo_title"
                    label="SEO Title"
                    rules={[
                      {
                        type: 'string',
                        message: 'SEO Title is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="SEO Title" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="seo_description"
                    label="SEO Description"
                    rules={[
                      {
                        type: 'string',
                        message: 'SEO Description is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="SEO Description" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="color_group_id"
                    label="Color Group ID"
                    rules={[
                      {
                        type: 'string',
                        message: 'Color Group ID is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Color Group ID" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="color_group_ref"
                    label="Color Group Ref"
                    rules={[
                      {
                        type: 'string',
                        message: 'Color Group Ref is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Color Group Ref" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="color_variants"
                    label="Color Variants"
                    rules={[
                      {
                        type: 'string',
                        message: 'Color Variants is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Color Variants" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="complementary"
                    label="Complementary"
                    rules={[
                      {
                        type: 'string',
                        message: 'Complementary is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Complementary" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="country_manufacture"
                    label="Country Manufacture"
                    rules={[
                      {
                        type: 'string',
                        message: 'Country Manufacture is Required',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Country"
                      options={[
                        { label: 'India', value: 'India' },
                        { label: 'China', value: 'China' },
                        { label: 'Bangladesh', value: 'Bangladesh' },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="country_of_manufacture"
                    label="Country of Manufacture"
                  >
                    <Select
                      placeholder="Select Country"
                      options={[
                        { label: 'India', value: 'India' },
                        { label: 'China', value: 'China' },
                        { label: 'Bangladesh', value: 'Bangladesh' },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="hero_product"
                    label="Hero Product"
                    rules={[
                      {
                        type: 'boolean',
                        message: 'Hero Product is Required',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Hero Product"
                      options={[
                        { label: 'Yes', value: true },
                        { label: 'No', value: false },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="cohort_remarks_1"
                    label="Cohort Remarks 1"
                    rules={[
                      {
                        type: 'string',
                        message: 'Cohort Remarks 1 is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Cohort Remarks 1" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="cohort_remarks_2"
                    label="Cohort Remarks 2"
                    rules={[
                      {
                        type: 'string',
                        message: 'Cohort Remarks 2 is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Cohort Remarks 2" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="cohort_remarks_3"
                    label="Cohort Remarks 3"
                    rules={[
                      {
                        type: 'string',
                        message: 'Cohort Remarks 3 is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Cohort Remarks 3" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item name="shopify_status" label="Shopify Status">
                    <Select
                      placeholder="Select Status"
                      options={[
                        { label: 'Active', value: true },
                        { label: 'Draft', value: false },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="product_category"
                    label="Product Category"
                    rules={[
                      {
                        type: 'string',
                        message: 'Product Category is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Product Category" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="product_type"
                    label="Type"
                    rules={[
                      {
                        type: 'string',
                        message: 'Product Type is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Product Type" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="option1_name"
                    label="Option 1 Name"
                    rules={[
                      {
                        type: 'string',
                        message: 'Option 1 Name is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Option 1 Name" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="option2_name"
                    label="Option 2 Name"
                    rules={[
                      {
                        type: 'string',
                        message: 'Option 2 Name is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Option 2 Name" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="option3_name"
                    label="Option 3 Name"
                    rules={[
                      {
                        type: 'string',
                        message: 'Option 3 Name is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Option 3 Name" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="collection"
                    label="Collection"
                    rules={[
                      {
                        type: 'string',
                        message: 'Collection is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Collection" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="fabric"
                    label="Fabric"
                    rules={[
                      {
                        type: 'string',
                        message: 'Fabric is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Fabric" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="features_specifications"
                    label="Features Specifications"
                    rules={[
                      {
                        type: 'string',
                        message: 'Features Specifications is Required',
                      },
                    ]}
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="Features Specifications"
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="knit_type"
                    label="Knit Type"
                    rules={[
                      {
                        type: 'string',
                        message: 'Knit Type is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Knit Type" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="launch_date"
                    label="Launch Date"
                    rules={[
                      {
                        required: true,
                        message: 'Launch Date is Required',
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Select Launch Date"
                    />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="launch_season"
                    label="Launch Season"
                    rules={[
                      {
                        required: true,
                        message: 'Launch Season is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Launch Season" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="life_occasion"
                    label="Life Occasion"
                    rules={[
                      {
                        type: 'string',
                        message: 'Life Occasion is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Life Occasion" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="material"
                    label="Material"
                    rules={[
                      {
                        type: 'string',
                        message: 'Material is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Material" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="material_care"
                    label="Material & Care"
                    rules={[
                      {
                        type: 'string',
                        message: 'Material & Care is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Material & Care" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="model_info"
                    label="Model Info"
                    rules={[
                      {
                        type: 'string',
                        message: 'Model Info is Required',
                      },
                    ]}
                  >
                    <Input.TextArea rows={4} placeholder="Model Info" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="sleeves"
                    label="Sleeves"
                    rules={[
                      {
                        type: 'string',
                        message: 'Sleeves is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Sleeves" />
                  </Form.Item>
                </Col>

                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="weight"
                    label="Weight"
                    rules={[
                      {
                        type: 'string',
                        message: 'Weight is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Weight" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="pattern"
                    label="Pattern"
                    rules={[
                      {
                        type: 'string',
                        message: 'Pattern is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Pattern" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="weave_structure"
                    label="Weave/structure"
                    rules={[
                      {
                        type: 'string',
                        message: 'Weave/structure is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Weave/Structure" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="length"
                    label="Length"
                    rules={[
                      {
                        type: 'string',
                        message: 'Length is Required',
                      },
                    ]}
                  >
                    <Input placeholder="Length" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="hem"
                    label="Hem"
                    rules={[
                      {
                        type: 'string',
                        message: 'Hem is Required',
                      },
                    ]}
                  >
                    <Input placeholder="hem" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="placket"
                    label="Placket"
                    rules={[
                      {
                        type: 'string',
                        message: 'Placket is Required',
                      },
                    ]}
                  >
                    <Input placeholder="hem" />
                  </Form.Item>
                </Col>
                <Col md={8} lg={8} sm={24} xs={24}>
                  <Form.Item
                    name="cuff"
                    label="Cuff"
                    rules={[
                      {
                        type: 'string',
                        message: 'Cuff is Required',
                      },
                    ]}
                  >
                    <Input placeholder="cuff" />
                  </Form.Item>
                </Col>

                {/* ------------Catalog Requirements ---------- */}

                {/* ------------ Catalog Requirements ---------- */}

                {/*------------ shopify catalog data end------*/}
                {/* <Divider orientation="left">Design Data</Divider> */}
                <div hidden={true}>
                  <Col md={8} lg={8} sm={24} xs={24} hidden={true}>
                    <div className="mandatoryMark">
                      <Form.Item name="sku" label="SKU">
                        <Input
                          placeholder="SKU"
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.designAttribute.includes(
                                role,
                              ),
                            )
                          }
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Description" name="description">
                      <TextArea
                        rows={2}
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                      />
                      {/* <Input placeholder="Enter Description" /> */}
                    </Form.Item>
                  </Col>

                  {/* new dropdowns for additional design attributes */}

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Color Family" name="color_family1">
                      <Select
                        disabled={true}
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={colorListOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Filter Color Grouping"
                      name="filter_color"
                    >
                      <Select
                        disabled={true}
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={filterColorListOptions}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item
                        label="Assumed MRP"
                        name="assumedMRP"
                        rules={[
                          {
                            message: 'Please enter a correct value',
                            pattern: new RegExp(
                              /^([0-9]{0,10}((.)[0-9]{0,4}))$/,
                            ),
                            message:
                              'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                          },
                        ]}
                      >
                        <Input
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.designAttribute.includes(
                                role,
                              ),
                            )
                          }
                          placeholder="Enter Assumed MRP"
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Design Season" name="design_season">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={seasonListOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Launch Season" name="launch_season">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={seasonListOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Life Occasion" name="lifeOccasion">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={lifeOccasionOptionList}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Sleeve" name="Sleeve">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={sleeveOptionList}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Silhouettes" name="silhouettes">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={silhouetteListOptions}
                        mode="single"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Design Category" name="designCategory">
                      <Select
                        placeholder="Select "
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={designCategoryOptionList}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Pattern" name="patterns">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={patternListOption}
                        mode="multiple"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Knit/Woven" name="knit_woven">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={knitWovenOptionList}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Freshness" name="freshness">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={freshnessOptionList}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Special Attributes"
                      name="special_attributes"
                    >
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={specialAttributeListOptions}
                        mode="multiple"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Garment Special Attributes"
                      name="garment_special_attributes"
                    >
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={specialAttributeListOptions}
                        mode="single"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Garment Special Attributes 2"
                      name="garment_special_attributes2"
                    >
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={specialAttributeListOptions}
                        mode="single"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Fabric Special Attribute"
                      name="fabric_special_attribute"
                    >
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {
                          // console.log('searching...', value);
                        }}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={fabricSpecialAttributeOptionList}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="addNewMasterNSelect">
                      <Form.Item
                        label="Trends"
                        name="trends"
                        style={{ minWidth: '300px', marginRight: '15px' }}
                      >
                        <Select
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.designAttribute.includes(
                                role,
                              ),
                            )
                          }
                          showSearch
                          onSearch={(value) => {}}
                          placeholder="Select "
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.trim().toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '')
                              .toLowerCase()
                              .localeCompare(
                                (optionB?.label ?? '').toLowerCase(),
                              )
                          }
                          options={trendListOptions}
                          mode="multiple"
                        />
                      </Form.Item>
                      <PlusOutlined
                        width={'20px'}
                        onClick={showModalTrend}
                        className="addIconForNewEntity"
                      />
                    </div>
                  </Col>

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Icons" name="icons">
                      <Select
                        placeholder="Select Icons"
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                      >
                        <Select.Option value="Fashion">Fashion</Select.Option>
                        <Select.Option value="Core">Core</Select.Option>
                        <Select.Option value="Experimental">
                          Experimental
                        </Select.Option>
                        <Select.Option value="Indian">Indian</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Weight" name="weight">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={weightOptionList}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Color Depth" name="color_depth">
                      <Select
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.designAttribute.includes(
                              role,
                            ),
                          )
                        }
                        showSearch
                        onSearch={(value) => {}}
                        placeholder="Select "
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.trim().toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={colorDepthOptionList}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Feature 1"
                      name="feature1"
                      rules={[
                        {
                          type: 'string',
                        },
                      ]}
                    >
                      <Input.TextArea placeholder="Feature 1 (by default Garment Special Attribute 1)" />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Feature 2"
                      name="feature2"
                      rules={[
                        {
                          type: 'string',
                        },
                      ]}
                    >
                      <Input.TextArea placeholder="Feature 2 (by default Garment Special Attribute 2)" />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Feature 3"
                      name="feature3"
                      rules={[
                        {
                          type: 'string',
                        },
                      ]}
                    >
                      <Input.TextArea placeholder="Feature 3 " />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Design Complete Date"
                      name="design_complete_date"
                      rules={[
                        {
                          type: 'object',
                        },
                      ]}
                    >
                      <DatePicker
                        format={dateFormat}
                        disabled={
                          true ||
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes?.edit?.designAttribute?.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                </div>

                <Row hidden={true}>
                  <Divider orientation="left">Planning Data</Divider>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item
                        label="MRP"
                        name="amrp"
                        rules={[
                          {
                            message: 'Please enter a correct value',
                            pattern: new RegExp(
                              /^([0-9]{0,10}((.)[0-9]{0,4}))$/,
                            ),
                            message:
                              'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter MRP"
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.planningAttribute.includes(
                                role,
                              ),
                            )
                          }
                        />
                      </Form.Item>

                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item
                        label="Projected Discount (%)"
                        name="proj_disc"
                        rules={[
                          {
                            message: 'Please enter a correct value',
                            pattern: new RegExp(
                              /^([0-9]{0,10}((.)[0-9]{0,4}))$/,
                            ),
                            message:
                              'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Projected Discount"
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.planningAttribute.includes(
                                role,
                              ),
                            )
                          }
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="ASP"
                      name="asp"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter ASP"
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.planningAttribute.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="ARV"
                      name="arv"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter ARV"
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.planningAttribute.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Total ARV"
                      name="total_arv"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Total ARV"
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.planningAttribute.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item
                        label="Planning Sub Category"
                        name="planning_prod_optn_type"
                      >
                        <Select
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.planningAttribute.includes(
                                role,
                              ),
                            )
                          }
                          showSearch
                          onSearch={(value) => {
                            // console.log('searching...', value);
                          }}
                          placeholder="Select "
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.trim().toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '')
                              .toLowerCase()
                              .localeCompare(
                                (optionB?.label ?? '').toLowerCase(),
                              )
                          }
                          options={ProductTypeOptions}
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item
                        label="Planning Product Category"
                        name="planning_prod_sub_cat"
                      >
                        <Select
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.planningAttribute.includes(
                                role,
                              ),
                            )
                          }
                          showSearch
                          onSearch={(value) => {
                            // console.log('searching...', value);
                          }}
                          placeholder="Select "
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.trim().toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '')
                              .toLowerCase()
                              .localeCompare(
                                (optionB?.label ?? '').toLowerCase(),
                              )
                          }
                          options={ProductCategoryOptions}
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Planning Complete Date"
                      name="planning_complete_date"
                      rules={[
                        {
                          type: 'object',
                        },
                      ]}
                    >
                      <DatePicker
                        disabled={
                          true ||
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes?.edit?.planningAttribute?.includes(
                              role,
                            ),
                          )
                        }
                        format={dateFormat}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row hidden={true}>
                  {/* ---- Merchendising - section ---- */}
                  <Divider orientation="left">Merchandising Data </Divider>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Target COGP"
                      name="target_cogs"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Target COGP"
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.merchAttribute.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item label="Factory" name="supplier_master">
                        <Select
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.merchAttribute.includes(
                                role,
                              ),
                            )
                          }
                          showSearch
                          onSearch={(value) => {
                            // console.log('searching...', value);
                          }}
                          placeholder="Select "
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.trim().toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '')
                              .toLowerCase()
                              .localeCompare(
                                (optionB?.label ?? '').toLowerCase(),
                              )
                          }
                          options={SupplierList.filter((supplier_item) =>
                            supplier_item?.label
                              ?.toLowerCase()
                              ?.includes('factory'),
                          )}
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="COGP"
                      name="cogs"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter COGP"
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.merchAttribute.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item
                        label="Total COGP"
                        name="total_cogs"
                        rules={[
                          {
                            message: 'Please enter a correct value',
                            pattern: new RegExp(
                              /^([0-9]{0,10}((.)[0-9]{0,4}))$/,
                            ),
                            message:
                              'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Total COGP"
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.merchAttribute.includes(
                                role,
                              ),
                            )
                          }
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="COGP %"
                      name="cogs_percentage"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter COGP %"
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.merchAttribute.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item
                        label="PO Price"
                        name="po_price"
                        rules={[
                          {
                            message: 'Please enter a correct value',
                            pattern: new RegExp(
                              /^([0-9]{0,10}((.)[0-9]{0,4}))$/,
                            ),
                            message:
                              'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                          },
                        ]}
                      >
                        <Input
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.merchAttribute.includes(
                                role,
                              ),
                            )
                          }
                          placeholder="Enter PO Price."
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Cost Of Finance"
                      name="cost_of_finance"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.merchAttribute.includes(
                              role,
                            ),
                          )
                        }
                        placeholder="Enter PO Price."
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item label="Payment Modal" name="payment_modal">
                        <Select
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.merchAttribute.includes(
                                role,
                              ),
                            )
                          }
                          showSearch
                          onSearch={(value) => {
                            // console.log('searching...', value);
                          }}
                          placeholder="Select "
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.trim().toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '')
                              .toLowerCase()
                              .localeCompare(
                                (optionB?.label ?? '').toLowerCase(),
                              )
                          }
                          options={paymentModalOptionList}
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Garment Weight"
                      name="garment_weight"
                      rules={[
                        {
                          message: 'Please enter a correct value',
                          pattern: new RegExp(/^([0-9]{0,10}((.)[0-9]{0,4}))$/),
                          message:
                            'Please enter a valid number, max decimal points is 4 e.g., 1000.0001',
                        },
                      ]}
                    >
                      <Input
                        disabled={
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes.edit.merchAttribute.includes(
                              role,
                            ),
                          )
                        }
                        placeholder="Enter Garment Weight."
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <div className="mandatoryMark">
                      <Form.Item label="Washcare Details" name="washcare">
                        <Select
                          disabled={
                            !user.rolesAssigned.find((role) =>
                              userRolesAllowedForAttributes.edit.merchAttribute.includes(
                                role,
                              ),
                            )
                          }
                          showSearch
                          onSearch={(value) => {
                            // console.log('searching...', value);
                          }}
                          placeholder="Select "
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.trim().toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '')
                              .toLowerCase()
                              .localeCompare(
                                (optionB?.label ?? '').toLowerCase(),
                              )
                          }
                          options={WashcareOptionList}
                        />
                      </Form.Item>
                      <Tooltip title="This is a required Field">
                        <ExclamationCircleTwoTone
                          twoToneColor={mandatoryIconColor}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Merch Complete Date"
                      name="merch_complete_date"
                      rules={[
                        {
                          type: 'object',
                        },
                      ]}
                    >
                      <DatePicker
                        format={dateFormat}
                        disabled={
                          true ||
                          !user.rolesAssigned.find((role) =>
                            userRolesAllowedForAttributes?.edit?.merchAttribute?.includes(
                              role,
                            ),
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Row>

              {/* hidden items*/}
              <Form.Item hidden={true} name="editId">
                <Input type="text" />
              </Form.Item>

              {/* hidden items*/}
              <Button
                className="addProduct_save_btn"
                disabled={!isEditable}
                htmlType="submit"
                type="primary"
                size="large"
              >
                {saving ? (
                  <>
                    <Spin size="small" /> Saving
                  </>
                ) : (
                  'Save'
                )}
              </Button>
            </Form>
          </div>

          <Modal
            title="Add New Trend"
            visible={isModalOpenTrend}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
            onOk={handleOkTrend}
            onCancel={handleCancelTrend}
            width={1000}
          >
            <Card className="addProduct_page_card">
              <Form
                form={modalformTrend}
                layout="vertical"
                onFinish={addNewEntityTrend}
                disabled={
                  !user.rolesAssigned.find((role) =>
                    userRolesAllowedForAttributes.edit.designAttribute.includes(
                      role,
                    ),
                  )
                }
              >
                <Row gutter={[16, 16]}>
                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item
                      label="Trend Name"
                      name="trend_name"
                      rules={[
                        {
                          required: true,
                          message: 'Trend name is required',
                          type: 'string',
                        },
                      ]}
                    >
                      <Input placeholder="Trend Name" />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} sm={24} xs={24}>
                    <Form.Item label="Trend Desrcription" name="description">
                      <Input placeholder="Trend Description" />
                    </Form.Item>
                  </Col>

                  <Form.Item label="Username" hidden={true} name="editEntityId">
                    <Input type="text" />
                  </Form.Item>

                  <Form.Item
                    label="Username"
                    hidden={true}
                    name="core_products"
                  >
                    <Input type="text" />
                  </Form.Item>
                </Row>
                <Button
                  disabled
                  className="addProduct_save_btn"
                  htmlType="submit"
                  type="primary"
                  size="large"
                >
                  {saving ? (
                    <>
                      <Spin size="small" /> Saving
                    </>
                  ) : (
                    'Save'
                  )}
                </Button>
              </Form>
            </Card>
          </Modal>
        </>
      )}
    </div>
  );
};

export default ShopifyProductDetails;
